/**
 * Wizard 2 Shopify API
 * Extends ShopifyAPI to use wizard-2 backend endpoints
 */
(function() {
  if (typeof ShopifyAPI === 'undefined') {
    console.error('wizard-2-shopify-api requires wizard-1-shopify-api.js');
    return;
  }

  class ShopifyAPIWizard2 extends ShopifyAPI {
    constructor(flowConfig) {
      super(flowConfig);
      this.backendApiUrl = window.__wizard2BackendApiUrl || null;
    }

    async createOrUpdatePetMetaobject(body) {
      if (!this.backendApiUrl) {
        throw new Error('Backend API URL is not configured');
      }

      const customerId =
        body.customerId || this._resolveCustomerIdForBackend(body.petMetaobjectId, null);
      const ownerEmail = String(body.ownerEmail || body.petData?.ownerEmail || '').trim();

      const response = await fetch(`${this.backendApiUrl}/api/wizard-2/pet-metaobject`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          petData: body.petData,
          calculations: body.calculations || {},
          customerId,
          ownerEmail: ownerEmail || undefined,
          petMetaobjectId: body.petMetaobjectId || null,
          resumeStep: body.resumeStep || null,
          selectedFlavors: body.selectedFlavors || body.selectedFlavorsFull || null,
          selectedFlavorsTrial: body.selectedFlavorsTrial || null,
          cartItems: body.cartItems || null
        })
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(err.message || 'Pet metaobject request failed');
      }

      const data = await response.json();
      if (!data.ok || !data.petMetaobjectId) {
        throw new Error('Invalid response from pet metaobject endpoint');
      }
      return { petMetaobjectId: data.petMetaobjectId };
    }

    /**
     * Clear customer reference on pet metaobject (keep metaobject; do not touch subscription id).
     * @param {string} petMetaobjectId
     * @param {string|null} customerId
     */
    async unlinkPetFromCustomer(petMetaobjectId, customerId = null) {
      if (!this.backendApiUrl) {
        throw new Error('Backend API URL is not configured');
      }
      if (!petMetaobjectId) {
        throw new Error('petMetaobjectId is required');
      }

      const resolvedCustomerId =
        customerId || this._resolveCustomerIdForBackend(petMetaobjectId, null);

      const response = await fetch(`${this.backendApiUrl}/api/wizard-2/unlink-pet-customer`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          petMetaobjectId,
          customerId: resolvedCustomerId || undefined,
        }),
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(err.message || 'Unlink pet from customer failed');
      }

      const data = await response.json();
      if (!data || data.ok === false) {
        throw new Error((data && data.message) || 'Unlink pet from customer failed');
      }
      return data;
    }
  }

  window.ShopifyAPIWizard2 = ShopifyAPIWizard2;
})();
